import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export const RequestDeleteName = ({ id }) => {
  const [message, setMessage] = useState(null);
  const { t } = useTranslation();

  const handleClick = async () => {
    const confirmation = window.confirm(t('confirm_delete'));
    if (!confirmation) return;

    try {
      const response = await fetch(`https://users.ponzilover.com/api/delete/${id}`);
      if (!response.ok) throw new Error("Network error");
      setMessage(t('process_request'));
    } catch (error) {
      setMessage(t('error_request'));
    }
  };

  return (
    <div className="text-center">
      {!message ? (
        <button
          onClick={handleClick}
          className="px-4 py-2 text-white font-semibold rounded-md shadow-md bg-orange-500 hover:bg-orange-700 transition duration-300"
        >
          {t('remove_profile')}
        </button>
      ) : (
        <p className="text-lg font-semibold text-gray-700">{message}</p>
      )}
    </div>
  );
};
